import * as Types from "../../../graphql/schemaTypes.generated";

import { BankAccountFieldsForUploadFragment } from "./bankAccountFieldsForUpload.generated";
import gql from "graphql-tag";
import { BankAccountFieldsForUploadFragmentDoc } from "./bankAccountFieldsForUpload.generated";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetContextualDataForUploadQueryVariables = Types.Exact<{
  bank_account_ids: Array<Types.Scalars["String"]>;
}>;

export type GetContextualDataForUploadQuery = { __typename?: "query_root" } & {
  bank_accounts: Array<
    { __typename?: "bank_accounts" } & BankAccountFieldsForUploadFragment
  >;
};

export const GetContextualDataForUploadDocument = gql`
  query GetContextualDataForUpload($bank_account_ids: [String!]!) {
    bank_accounts(where: { account_id: { _in: $bank_account_ids } }) {
      ...bankAccountFieldsForUpload
    }
  }
  ${BankAccountFieldsForUploadFragmentDoc}
`;

export function useGetContextualDataForUploadQuery(
  options: Omit<
    Urql.UseQueryArgs<GetContextualDataForUploadQueryVariables>,
    "query"
  > = {}
) {
  return Urql.useQuery<GetContextualDataForUploadQuery>({
    query: GetContextualDataForUploadDocument,
    ...options,
  });
}
